import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import WhosGoing from "@/pages/WhosGoing";
import BawainerProfile from "@/pages/BawainerProfile";
import PostTrip from "@/pages/PostTrip";
import MyTrips from "@/pages/MyTrips";
import RequestBoard from "@/pages/RequestBoard";
import MyRequests from "@/pages/MyRequests";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import Messages from "@/pages/Messages";
import Chat from "@/pages/Chat";
import WalletPage from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import Notifications from "@/pages/Notifications";
import Verification from "@/pages/Verification";
import Admin from "@/pages/Admin";
import { Safety, Legal } from "@/pages/Static";

function RootRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/legal/:doc" element={<Legal />} />

      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/home" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/whos-going" element={<WhosGoing />} />
        <Route path="/bawainer/:id" element={<BawainerProfile />} />
        <Route path="/post-trip" element={<ProtectedRoute roles={["bawainer"]}><PostTrip /></ProtectedRoute>} />
        <Route path="/my-trips" element={<ProtectedRoute roles={["bawainer"]}><MyTrips /></ProtectedRoute>} />
        <Route path="/post-request" element={<RequestBoard />} />
        <Route path="/requests" element={<MyRequests />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/chat/:convId" element={<Chat />} />
        <Route path="/wallet" element={<ProtectedRoute roles={["bawainer"]}><WalletPage /></ProtectedRoute>} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <RootRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
